<!--<template>-->
<!--  <div v-if="!item.hidden">-->
<!--    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">-->
<!--      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path, onlyOneChild.query)">-->
<!--        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">-->
<!--          <item :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="onlyOneChild.meta.title" />-->
<!--        </el-menu-item>-->
<!--      </app-link>-->
<!--    </template>-->

<!--    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>-->
<!--      <template slot="title">-->
<!--        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />-->
<!--      </template>-->
<!--      <sidebar-item-->
<!--        v-for="(child, index) in item.children"-->
<!--        :key="child.uniqueKey"-->
<!--        :is-nest="true"-->
<!--        :item="child"-->
<!--        :base-path="resolvePath(child.path)"-->
<!--        class="nest-menu"-->
<!--      />-->
<!--    </el-submenu>-->
<!--  </div>-->
<!--</template>-->
<template>
  <div v-if="!item.hidden">
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link v-if="onlyOneChild.meta" :to="getIframePath(onlyOneChild)">
        <!-- 叶子菜单index用真实路由路径用于高亮 -->
        <el-menu-item :class="{'submenu-title-noDropdown':!isNest}" :index="onlyOneChild.path">
          <item :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="onlyOneChild.meta.title" />
        </el-menu-item>
      </app-link>
    </template>
    <!-- 一级父菜单：index强制uniqueKey -->
    <el-submenu v-else ref="subMenu" :index="item.uniqueKey" popper-append-to-body>
      <template slot="title">
        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
      </template>
      <!-- 递归子菜单：子submenu同样绑定child.uniqueKey -->
      <sidebar-item
        v-for="(child, index) in item.children"
        :key="child.uniqueKey"
        :base-path="resolvePath(child.path)"
        :is-nest="true"
        :item="child"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>
<script>
import path from 'path'
import { isExternal } from '@/utils/validate'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    this.onlyOneChild = null
    return {}
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      // 当前菜单是iframe一级页面，直接判定为单叶子，渲染el-menu-item
      if(parent.meta?.isIframePage) {
        this.onlyOneChild = parent
        return true
      }
      if (!children) {
        children = []
      }
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        }
        this.onlyOneChild = item
        return true
      })

      if (showingChildren.length === 1) {
        return true
      }
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: parent.path, noShowingChildren: true }
        return true
      }
      return false
    },

    getIframePath(routeItem) {
      // 有 meta.link 时走 IframeToggle（v-show 切换），不需要额外 query.url 参数
      if (routeItem.meta && routeItem.meta.link) {
        return { path: routeItem.path }
      }
      if (routeItem.meta && routeItem.meta.iframeUrl) {
        const target = {
          path: routeItem.path,
          query: { url: routeItem.meta.iframeUrl }
        }
        console.log('跳转目标路由', target)
        return target
      }
      return this.resolvePath(routeItem.path || '', routeItem.query)
    },
    // getIframePath(routeItem) {
    //   // 外链旧html页面，新窗口打开
    //   if (routeItem.external) {
    //     const htmlPath = routeItem.htmlPath
    //     let fullUrl = ''
    //     if (import.meta.env.DEV) {
    //       fullUrl = `http://localhost:8081/modules/${htmlPath}`
    //     } else {
    //       fullUrl = `/modules/${htmlPath}`
    //     }
    //     window.open(fullUrl)
    //     return ''
    //   }
    //
    //   // 原有iframe路由跳转逻辑
    //   if (routeItem.meta && routeItem.meta.iframeUrl) {
    //     const target = {
    //       path: routeItem.path,
    //       query: { url: routeItem.meta.iframeUrl }
    //     }
    //     console.log('跳转目标路由', target)
    //     return target
    //   }
    //   return this.resolvePath(routeItem.path || '', routeItem.query)
    // },
      // getIframePath(routeItem) {
      //   // 如果是iframe页面，拼接query参数
      //   if (routeItem.meta && routeItem.meta.iframeUrl) {
      //     return {
      //       path: routeItem.path,
      //       query: { url: routeItem.meta.iframeUrl }
      //     }
      //   }
      //   return this.resolvePath(routeItem.path || '', routeItem.query || '')
      // },
      // 原有resolvePath...
    resolvePath(routePath, routeQuery) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      if (routeQuery) {
        let query = JSON.parse(routeQuery)
        return { path: path.resolve(this.basePath, routePath), query: query }
      }
      return path.resolve(this.basePath, routePath)
    }
  }
}
</script>
